exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sbolMain[data-v-3334167f]{overflow:scroll;font-size:.875rem;font-weight:400;line-height:1.5;color:#202832;text-align:left;margin:0;padding:10px}.panel[data-v-3334167f]{position:absolute;right:1em;font-size:2em}.empty[data-v-3334167f]{background-color:#f0f2f5;border-radius:3px;padding:20px;text-align:center;overflow:hidden}.SBOLcontainer[data-v-3334167f]{display:grid;grid-template-columns:1fr 2fr;height:675px}nav[data-v-3334167f]{padding:0 5px 0 0;min-width:300px}", ""]);

// exports
